import { createContext, useContext, useState, useEffect } from 'react';
import { getSettings } from '@/lib/api';

const SettingsContext = createContext({});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  
  useEffect(() => {
    getSettings().then(r => {
      setSettings(r.data);
      
      // Dynamically update OG meta tags if set in settings
      const ogUpdates = [
        { property: 'og:image', content: r.data.og_image_url },
        { property: 'og:title', content: r.data.og_title },
        { property: 'og:description', content: r.data.og_description },
        { name: 'twitter:image', content: r.data.og_image_url },
        { name: 'twitter:title', content: r.data.og_title },
        { name: 'twitter:description', content: r.data.og_description },
      ];
      ogUpdates.forEach(({ property, name, content }) => {
        if (!content) return;
        const selector = property
          ? `meta[property='${property}']`
          : `meta[name='${name}']`;
        const existing = document.querySelector(selector);
        if (existing) {
          existing.setAttribute('content', content);
        } else {
          const meta = document.createElement('meta');
          if (property) meta.setAttribute('property', property);
          if (name) meta.setAttribute('name', name);
          meta.setAttribute('content', content);
          document.head.appendChild(meta);
        }
      });

      // Dynamically update favicon if set in settings
      if (r.data.favicon_url) {
        const existingFavicon = document.querySelector("link[rel='icon']");
        if (existingFavicon) {
          existingFavicon.href = r.data.favicon_url;
        } else {
          const link = document.createElement('link');
          link.rel = 'icon';
          link.href = r.data.favicon_url;
          document.head.appendChild(link);
        }
        
        // Also update apple-touch-icon if exists
        const appleFavicon = document.querySelector("link[rel='apple-touch-icon']");
        if (appleFavicon) {
          appleFavicon.href = r.data.favicon_url;
        }
      }
    }).catch(() => {});
  }, []);
  
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
